var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"empty:hidden"},[(_vm.table.content)?_c('BaseGridLayout',{attrs:{"size":"small"}},[_c('BaseTable',_vm._b({attrs:{"id":_vm.anchorName}},'BaseTable',_vm.table,false))],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }